/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { UserModel, UserModelType } from './UserModel'
import { UserModelSelector } from './UserModel.base'
import { RootStoreType } from './index'

/**
 * InputPlayerStatsBase
 * auto generated base class for the model InputPlayerStatsModel.
 */
export const InputPlayerStatsModelBase = ModelBase.named('InputPlayerStats')
  .props({
    __typename: types.optional(types.literal('InputPlayerStats'), 'InputPlayerStats'),
    checkpoint: types.union(types.undefined, types.number),
    chips: types.union(types.undefined, types.number),
    isLeft: types.union(types.undefined, types.null, types.boolean),
    isRemovedByTeacher: types.union(types.undefined, types.null, types.boolean),
    numberOfHandsPlayed: types.union(types.undefined, types.number),
    playerId: types.union(types.undefined, types.string),
    playerName: types.union(types.undefined, types.string),
    playerOutRank: types.union(types.undefined, types.number),
    playerOutTime: types.union(types.undefined, types.number),
    previousHandChips: types.union(types.undefined, types.number),
    stack: types.union(types.undefined, types.number),
    state: types.union(types.undefined, types.string),
    userId: types.union(
      types.undefined,
      types.late(() => UserModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class InputPlayerStatsModelSelector extends QueryBuilder {
  get checkpoint() {
    return this.__attr('checkpoint')
  }
  get chips() {
    return this.__attr('chips')
  }
  get isLeft() {
    return this.__attr('isLeft')
  }
  get isRemovedByTeacher() {
    return this.__attr('isRemovedByTeacher')
  }
  get numberOfHandsPlayed() {
    return this.__attr('numberOfHandsPlayed')
  }
  get playerId() {
    return this.__attr('playerId')
  }
  get playerName() {
    return this.__attr('playerName')
  }
  get playerOutRank() {
    return this.__attr('playerOutRank')
  }
  get playerOutTime() {
    return this.__attr('playerOutTime')
  }
  get previousHandChips() {
    return this.__attr('previousHandChips')
  }
  get stack() {
    return this.__attr('stack')
  }
  get state() {
    return this.__attr('state')
  }
  userId(builder: string | UserModelSelector | ((selector: UserModelSelector) => UserModelSelector) | undefined) {
    return this.__child('userId', UserModelSelector, builder)
  }
}
export function selectFromInputPlayerStats() {
  return new InputPlayerStatsModelSelector()
}

export const inputPlayerStatsModelPrimitives =
  selectFromInputPlayerStats().checkpoint.chips.isLeft.isRemovedByTeacher.numberOfHandsPlayed.playerId.playerName
    .playerOutRank.playerOutTime.previousHandChips.stack.state
